var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"count-down"},[_c('i',{staticClass:"icon"}),_c('p',{staticClass:"normal-que-count count-time",domProps:{"innerHTML":_vm._s(_vm.countdownDesc)}}),_c('ClassBtn',{attrs:{"is-extra-time":false},on:{"realEnd":_vm.realEnd,"end":_vm.end}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }